import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'selectionDisplay']

  connect() {
    this.element.addEventListener('input', this.update.bind(this))
    this.update()
  }

  update() {
    const total = this.checkboxTargets.length
    const selected = this.checkboxTargets.
      filter((checkbox) => checkbox.checked).
      length

    this.selectionDisplayTarget.textContent = `${selected} of ${total} selected`
  }
}
